import React from "react";

export default function Spark() {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 235 235"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="spark"
    >
      <g
        clipPath="url(#paint0_diamond_515_15_clip_path)"
        data-figma-skip-parse="true"
      >
        <g transform="matrix(0 0.1175 -0.1175 0 117.5 117.5)">
          <rect
            x="0"
            y="0"
            width="1008.51"
            height="1008.51"
            fill="url(#paint0_diamond_515_15)"
            opacity="1"
            shapeRendering="crispEdges"
          />
          <rect
            x="0"
            y="0"
            width="1008.51"
            height="1008.51"
            transform="scale(1 -1)"
            fill="url(#paint0_diamond_515_15)"
            opacity="1"
            shapeRendering="crispEdges"
          />
          <rect
            x="0"
            y="0"
            width="1008.51"
            height="1008.51"
            transform="scale(-1 1)"
            fill="url(#paint0_diamond_515_15)"
            opacity="1"
            shapeRendering="crispEdges"
          />
          <rect
            x="0"
            y="0"
            width="1008.51"
            height="1008.51"
            transform="scale(-1)"
            fill="url(#paint0_diamond_515_15)"
            opacity="1"
            shapeRendering="crispEdges"
          />
        </g>
      </g>
      <circle
        cx="117.5"
        cy="117.5"
        r="117.5"
        data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_DIAMOND&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.69395852088928223,&#34;g&#34;:0.52916663885116577,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.49404752254486084,&#34;g&#34;:0.29166665673255920,&#34;b&#34;:1.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:0.69395852088928223,&#34;g&#34;:0.52916663885116577,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:0.49404752254486084,&#34;g&#34;:0.29166665673255920,&#34;b&#34;:1.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;transform&#34;:{&#34;m00&#34;:1.4389600689929290e-14,&#34;m01&#34;:-235.0,&#34;m02&#34;:235.0,&#34;m10&#34;:235.0,&#34;m11&#34;:1.4389600689929290e-14,&#34;m12&#34;:-1.4389600689929290e-14},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
      />
      <defs>
        <clipPath id="paint0_diamond_515_15_clip_path">
          <circle cx="117.5" cy="117.5" r="117.5" />
        </clipPath>
        <linearGradient
          id="paint0_diamond_515_15"
          x1="0"
          y1="0"
          x2="500"
          y2="500"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B187FF" />
          <stop offset="1" stopColor="#7E4AFF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
